module.exports = __webpack_public_path__ + "img/404.5cd6e4e5.jpg";